export default {
    targets: ["list"],
    showHistory(event) {
        event.currentTarget.classList.add("hidden");
        this.listTarget.classList.remove("hidden");
    },
};
